import { BaseSelect } from "@/shared/ui/base-select";
import { MenuItem } from "@mui/material";

type Props = {
  value: string;
  onChange: (value: string | undefined) => void;
};

export const MobileSelectOrderBy = ({ value, onChange }: Props) => {
  return (
    <BaseSelect
      type="string"
      value={value}
      size="small"
      // TODO: APIのソート実装までは表示しない
      sx={{ display: { xs: "none", sm: "none" } }}
      onChange={onChange}
    >
      <MenuItem value="loadingOn">積日：昇順</MenuItem>
      <MenuItem value="-loadingOn">積日：降順</MenuItem>
      <MenuItem value="unloadingOn">卸日：昇順</MenuItem>
      <MenuItem value="-unloadingOn">卸日：降順</MenuItem>
      <MenuItem value="shippingFee">運賃：昇順</MenuItem>
      <MenuItem value="-shippingFee">運賃：降順</MenuItem>
      <MenuItem value="expiration">受付期限：昇順</MenuItem>
      <MenuItem value="-expiration">受付期限：降順</MenuItem>
    </BaseSelect>
  );
};
